import { render } from "./ForumPage.vue?vue&type=template&id=1b97c059&scoped=true"
import script from "./ForumPage.vue?vue&type=script&lang=js"
export * from "./ForumPage.vue?vue&type=script&lang=js"

import "./ForumPage.vue?vue&type=style&index=0&id=1b97c059&lang=css"
import "./ForumPage.vue?vue&type=style&index=1&id=1b97c059&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b97c059"]])

export default __exports__